import { Component, Prop, Vue } from "vue-property-decorator";

import ModalBase from "../modalBase/modalBase";

@Component({ components: { ModalBase } })
export default class ModalTemporaryClosing extends Vue {
  @Prop({ default: false }) isActive;

  currentStep = 1;

  get mainButtonLabel() {
    if (this.currentStep < 4) return "Seguir leyendo";
    return "Ir a conocer";
  }

  get bannerSrc() {
    switch (this.currentStep) {
      case 1:
        return "https://s3.us-east-1.amazonaws.com/partner.todoscomemos.com/img/01%20modal.png";
      case 2:
        return "https://s3.us-east-1.amazonaws.com/partner.todoscomemos.com/img/02%20modal.png";
      case 3:
        return "https://s3.us-east-1.amazonaws.com/partner.todoscomemos.com/img/03%20modal.png";
      case 4:
        return "https://s3.us-east-1.amazonaws.com/partner.todoscomemos.com/img/04%20modal.png";
    }
  }

  onMainButtonClick() {
    if (this.currentStep === 4) {
      window.open("https://app.foody.com.co/programar");
    } else {
      this.currentStep++;
    }
  }

  onModalClose() {
    this.currentStep = 1;
    this.$emit("modal-close");
  }
}
